import {DrawerProps} from "antd";

export const SECTIONS = {
  general: {
    id: 0,
    name: 'Home',
  },
  configuration: {
    id: 1,
    name: 'Configuration',
  },
  operation: {
    id: 2,
    name: 'Operation',
  },
  batchProcessing: {
    id: 3,
    name: 'Batch processing',
  },
  administration: {
    id: 4,
    name: 'Administration',
  },
  report: {
    id: 5,
    name: 'Report',
  },
  notifications: {
    id: 6,
    name: 'Notifications',
  },
  excelAddin: {
    id: 7,
    name: 'Excel Addin',
  }
}

export const OPERATIONS = {
  IMPORT: 1,
  LEGACY: 2,
  VALIDATION: 3,
  ENRICHMENT: 4,
  LOADFILE: 5,
}

export const DATA_TYPES = [
  { label: "bigint", value: "bigint" },
  { label: "bit", value: "bit" },
  { label: "decimal", value: "decimal" },
  { label: "int", value: "int" },
  { label: "numeric", value: "numeric" },
  { label: "tinyint", value: "tinyint" },
  { label: "date", value: "date" },
  { label: "datetime", value: "datetime" },
  { label: "datetime2", value: "datetime2" },
  { label: "datetimeoffset", value: "datetimeoffset" },
  { label: "smalldatetime", value: "smalldatetime" },
  { label: "time", value: "time" },
  { label: "varchar", value: "varchar" },
  { label: "varchar(max)", value: "varchar(max)" },
  { label: "text", value: "text" },
  { label: "ntext", value: "ntext" },
  { label: "nvarchar", value: "nvarchar" },
  { label: "nvarchar(max)", value: "nvarchar(max)" },
  { label: "timestamp", value: "timestamp" },
  { label: "uniqueidentifier", value: "uniqueidentifier" },
  { label: "xml", value: "xml" }
];

export const HTTPCODES = {
  Ok: 200,
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  InternalServerError: 500,
  BadGateway: 502,
  ServiceUnavailable: 503,
};

export const NOTIFICATION_TYPES = {
  SUCCESS: 1,
  ERROR: 2,
  INFO: 3,
}

export const MATCHING_SCORE_TYPE = {
  EXACT: 0,
  FUZZY: 1,
}

interface DRAWER_PLACEMENT_PROPS {
  BOTTOM: DrawerProps["placement"],
  LEFT: DrawerProps["placement"],
  RIGHT: DrawerProps["placement"],
  TOP: DrawerProps["placement"]
}

export const DRAWER_PLACEMENTS : DRAWER_PLACEMENT_PROPS = {
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right",
  TOP: "top"
}

